var map = {
	"./manage-price-group/manage-price-group.module": [
		"./src/app/settings/manage-price-group/manage-price-group.module.ts",
		"manage-price-group-manage-price-group-module"
	],
	"app/settings/settings.module": [
		"./src/app/settings/settings.module.ts",
		"app-settings-settings-module"
	],
	"app/shipment/customers/customers.module": [
		"./src/app/shipment/customers/customers.module.ts",
		"app-shipment-customers-customers-module"
	],
	"app/shipment/invoice/invoice.module": [
		"./src/app/shipment/invoice/invoice.module.ts",
		"common",
		"app-shipment-invoice-invoice-module"
	],
	"app/shipment/shipment.module": [
		"./src/app/shipment/shipment.module.ts",
		"app-shipment-shipment-module"
	],
	"app/shipment/shipments/shipments.module": [
		"./src/app/shipment/shipments/shipments.module.ts",
		"common",
		"app-shipment-shipments-shipments-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;